import {
  JsonFormsRendererRegistryEntry,
  JsonSchema,
  UISchemaElement,
} from "@jsonforms/core";
import { JsonFormsDispatch } from "@jsonforms/react";
import { useContext, ReactNode } from "react";

import { BaseLayoutContext } from "./BaseLayoutContext";
import { RenderError } from "../components/helpers/RenderError";
import { isLayout } from "../utils";

interface ChildProps {
  key: string;
  path: string;
  schema: JsonSchema;
  uischema: UISchemaElement;
  enabled: boolean;
  visible: boolean;
}

interface Props {
  className?: string;
  renderers?: JsonFormsRendererRegistryEntry[];
  children?: (props: ChildProps) => ReactNode;
}

export function BaseLayoutContent(props: Props) {
  const { path, schema, uischema, enabled, visible } =
    useContext(BaseLayoutContext);

  if (!isLayout(uischema)) {
    return <RenderError>Invalid Layout</RenderError>;
  }

  const elements = uischema.elements || [];

  return (
    <>
      {elements.map((uischema, index) => {
        if (props.children) {
          return props.children({
            key: `${path}-${index}`,
            path,
            schema,
            uischema,
            enabled,
            visible,
          });
        } else {
          return (
            <JsonFormsDispatch
              key={`${path}-${index}`}
              schema={schema}
              uischema={uischema}
              path={path}
              enabled={enabled}
              visible={visible}
              renderers={props.renderers}
            />
          );
        }
      })}
    </>
  );
}
